import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		height: '100%'
	},
	media: {
		height: 200
	}
})

export default function New({ image, title, url }) {
	const classes = useStyles()

	return (
		<Card className={classes.root}>
			<CardMedia className={classes.media} image={image} title={title} />
			<CardContent>
				<Typography variant="h6" component="h3">
					{title}
				</Typography>
			</CardContent>
			<CardActions>
				<Button size="small" style={{ color: '#e93f3e' }} href={url} target="_blank">
					Leer más
				</Button>
			</CardActions>
		</Card>
	)
}
